module.exports = __webpack_public_path__ + "media/applicants/shopper-safety-36e37356.webp";